import React, { useState } from 'react';

import { PhotoCropperModal } from '../../../components/photo-cropper-modal/photo-cropper.modal';
import { DropdownMenu } from '../../../components/modals/dropdown-menu/DropdownMenu';
import { openModal } from '../../../core/modal/open-modal';
import { DeleteDialog } from '../../../components/dialogs/DeleteDialog';

import type { Project } from '../../../app/entities/project';

import styles from './header-simple-widget.module.scss';
export type HeaderSimpleWidgetProps = {
  project: Project;
  src: string;
  text: string;
};

export const HeaderSimpleWidget: React.FC<HeaderSimpleWidgetProps> = ({ project, src, text }) => {
  const [imgSrc, setImgSrc] = React.useState(src);
  const [isImageModalOpen, setIsImageModalOpen] = useState<boolean>(false);

  const handleUpload = (blob: Blob) => {
    setImgSrc(URL.createObjectURL(blob));

    project.update({
      [text.toLowerCase()]: {
        logo: {
          fileType: blob.type,
          size: blob.size,
          file: blob,
        },
      },
    });
  };

  const handleRemoveLogo = () => {
    openModal(DeleteDialog, {
      onSubmit: () => {
        project
          .update({
            [text.toLowerCase()]: {
              logo: null,
            },
          })
          .then(() => {
            setImgSrc(null);
          });
      },
      text: 'Remove logo?',
      title: 'Are you sure you want to remove this logo?',
    });
  };

  return (
    <div className={styles['card']}>
      <div className={styles['menu-handle']}>
        <DropdownMenu
          items={[
            {
              onSelect: () => setIsImageModalOpen(true),
              title: 'Update logo',
            },
            {
              onSelect: handleRemoveLogo,
              title: 'Remove logo',
              type: 'danger',
              disabled: !src,
            },
          ]}
        />
      </div>

      <div className={styles['mobile-header']}>
        <h6 className={styles['text']}>{text}</h6>
      </div>

      {imgSrc ? (
        <div className={styles['logo-holder']}>
          <img className={styles['logo']} src={imgSrc} />
        </div>
      ) : (
        <div className={styles['logo-placeholder']} onClick={() => setIsImageModalOpen(true)}>
          Add logo
        </div>
      )}

      <div />

      {isImageModalOpen && (
        <PhotoCropperModal
          theme="light"
          onCancel={() => setIsImageModalOpen(false)}
          onSave={handleUpload}
          aspectRatio={{
            minimum: 1,
            maximum: 4.5,
          }}
        />
      )}
    </div>
  );
};
